import React, { useState } from 'react';
import { Box, Headline, Text } from '@freenow/wave';
import { ClickableHeaderContent } from '../ClickableHeaderContent';
import { DropdownItems } from './components/DropdownItems';
import { ReloadCombIcon } from './components/ReloadCombination';
export const ErrorPanel = ({ title, subTitle, detailsTitle, buttonTitle, errorStack, showMoreInformation = false, }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (React.createElement(Box, { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", minHeight: "100vh" },
        React.createElement(ReloadCombIcon, null),
        React.createElement(Headline, { as: "h3", mb: "2" }, title),
        React.createElement(Text, { as: "p", mb: "2" }, subTitle),
        showMoreInformation && errorStack ? (React.createElement(Box, { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" },
            React.createElement(ClickableHeaderContent, { onClick: () => setIsOpen(!isOpen), detailsTitle: detailsTitle, isOpen: isOpen }),
            React.createElement(DropdownItems, { buttonTitle: buttonTitle, errorText: errorStack, isOpen: isOpen }))) : null));
};
